module.exports = __webpack_public_path__ + "static/media/room_delete_gold.6aeedd82.svg";